import React from 'react';
import { connect } from 'react-redux';
import './Common.css';
import './HomePage.css';
import './AgreementLanding.css';
import NewAgreementButton from './NewAgreementButton';
import HowItWorks from './HowItWorks';
import usePageAnchor from './usePageAnchor';

function HomePage({ auth, hash }) {
  const loggedIn = auth.status === 'loggedin';
  usePageAnchor(hash);

  return (
    <main className="homeSection agreementHome">
      <section className="agreementHero">
        <div className="agreementHomeInner">
          <div className="agreementEyebrow">Your terms. Your agreement.</div>
          <h1>Make an agreement.<br />Put something at stake.</h1>
          <p className="agreementIntro">
            Agree on the details with someone you know. Define the terms,
            agree on an arbitrator, and use our Ethereum contracts to enforce the agreement.
          </p>
          {loggedIn && <p className="agreementWelcome">Welcome back, {auth.username}.</p>}
          <div className="agreementHomeActions">
            <NewAgreementButton />
            <a className="agreementTextLink" href={loggedIn ? '/contracts' : '#howitworks'}>
              {loggedIn ? 'Your contracts' : 'How it works'} <span aria-hidden="true">→</span>
            </a>
          </div>
          <p className="agreementFinePrint">On-chain transactions require an Ethereum wallet and network fees.</p>
        </div>
      </section>

      <HowItWorks />

      <section className="agreementHelp">
        <div className="agreementHomeInner">
          <h2>Understand what you’re agreeing to.</h2>
          <p>Learn about escrow, incentives, and the steps involved before committing funds.</p>
          <div className="agreementHomeActions">
            <a className="agreementTextLink" href="/incentives">Escrow &amp; incentives</a>
            <a className="agreementTextLink" href="/help#gettingstarted">Getting started</a>
            <a className="agreementTextLink" href="/faq">FAQ</a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default connect(state => ({ auth: state.auth, hash: state.menu.hash }))(HomePage);
